import { useCallback, useState } from 'react';

import { USCityView } from '@zola/svc-marketplace-ts-types';
import TotallyWowed2 from '@zola/zola-ui/src/assets/images/icons/totally_wowed_2.svg';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';

import { Form } from 'react-final-form';

import AutoSuggestLocationField from '~/components/common/form/AutoSuggestLocationField/AutoSuggestLocationField';

import styles from './vendorStarterPackForm.module.less';

export type VendorStarterPackFormProps = {
  hideModalFn: () => void;
  currentCity?: USCityView;
  changeCity: (city: USCityView, marketId: number | null) => void;
};

export const VendorStarterPackFormModal = (props: VendorStarterPackFormProps): JSX.Element => {
  const { changeCity, hideModalFn, currentCity } = props;
  const [selectedCity, setSelectedCity] = useState<USCityView>();

  const onSuggestionSelected = useCallback(
    (_event: React.SyntheticEvent, { suggestion }: { suggestion: USCityView }) => {
      setSelectedCity(suggestion);
    },
    []
  );

  const onSubmit = () => {
    const vendorMarketId = selectedCity?.vendorMarket?.id;
    if (vendorMarketId && selectedCity) {
      changeCity(selectedCity, vendorMarketId);
    }
    hideModalFn();
  };

  return (
    <div className={styles.modal}>
      <div className={styles.hed}>
        <CircleIcon image={TotallyWowed2} variant="transparent" />
        <h2>Edit your location</h2>
      </div>
      <p> We&apos;ll use it to suggest vendors.</p>
      <hr />
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit as () => void} className={styles.formWrapper}>
            <AutoSuggestLocationField
              onSuggestionSelected={onSuggestionSelected}
              placeholder="Wedding Location"
              useLabel
              inputV2
              showIcon
              name="wedding-location"
              labelText="Location (City, State)"
              value={currentCity}
              highlightFirstSuggestion
            />
            <div className={styles.ctaWrapper}>
              <ButtonV3 variant="secondary" onClick={() => hideModalFn()}>
                Cancel
              </ButtonV3>
              <ButtonV3 type="submit">Save</ButtonV3>
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default VendorStarterPackFormModal;
